import axios from "axios";

export const brandApis = {
  getAll: () => {
    return axios
      .get(`/Brands/GetAll`, {
        headers: {
          "Access-Control-Allow-Origin": true,
          "Content-type": "application/json",
        },
      })
      .then((res) => res.data.data)
      .catch((e) => console.log(e));
  },
};
